/** en-GB date + en-US 12h time — shared by admin feedback/match views. */

export const formatDate = (value) => {
  if (!value) return '-';
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const formatTime = (value) => {
  if (!value) return '-';
  const parsed = new Date(`1970-01-01T${value}`);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: true });
};

export const formatDateTime = (dateValue, timeValue) => {
  const dateText = formatDate(dateValue);
  const timeText = formatTime(timeValue);
  if (dateText === '-' && timeText === '-') return '-';
  if (dateText === '-') return timeText;
  if (timeText === '-') return dateText;
  return `${dateText} ${timeText}`;
};
